import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Welcome from './pages/Login/Welcome';
import LoginPage from './pages/Login/Login';
import Register from './pages/Login/Register';
import ResetPassword from './pages/Login/ResetPassword';
import SetPassword from './pages/Login/SetPassword';
import PreHome from './pages/PreHome/PreHome';
import Home from './pages/Chatting/Home';
import QuizSet from './pages/Quiz/QuizSet';
import PublicTestList from './pages/Quiz/PublicTestList';
import TestGenerator from './pages/Quiz/TestGenerator';
import QuizGenerator from './pages/Quiz/QuizGenerator';
import Quiz from './pages/Quiz/Quiz';
import ChatHistory from './pages/Chatting/ChatHistory';
import ContactUs from './pages/ContactUs/ContactUs';
import MyDocuments from './pages/MyDocuments/MyDocuments';
import MySchedule from './pages/MySchedule/MySchedule';
import Setting from './pages/Setting/Setting';
import Sharing from './pages/Sharing/Sharing';
import NotFound from './pages/NotFound';
import StoredUserContext from './context/StoredUserContext';
import GlobalClickEffect from './components/GlobalClickEffect/GlobalClickEffect'
import PublicQuiz from './pages/Quiz/PublicQuiz';
import LoginPageCN from './pages/Login/LoginCN';
import Plan from './pages/Plan/Plan';



function App() {

  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const tempUser = useState(JSON.parse(localStorage.getItem('tempUser')));
  return (
    <Router>
      <StoredUserContext.Provider value={[user, setUser]}>
        <GlobalClickEffect />
        <Routes>
          <Route exact path="/" element={<Welcome />} />
          <Route path="/login/:referer" element={user ? <Navigate to="/pre-home" replace={true} /> : <LoginPage />} />
          <Route path="/login" element={user ? <Navigate to="/pre-home" replace={true} /> : <LoginPage />} />
          <Route path="/login-china" element={user ? <Navigate to="/pre-home" replace={true} /> : <LoginPageCN />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/pre-home" element={user ? <PreHome /> : <Navigate to="/login" replace={true} />} />
          <Route path="/g1" element={<PublicQuiz />} />
          <Route path="/public-quiz" element={(user || tempUser) ? <PublicQuiz /> : <Navigate to="/login" replace={true} />} />
          <Route path="/home" element={user ? <Home /> : <Navigate to="/login" replace={true} />} />
          <Route path="/quiz-set" element={user ? <QuizSet /> : <Navigate to="/login" replace={true} />} />
          <Route path="/public-test-list" element={<PublicTestList />} />
          <Route path="/test-generator" element={user ? <TestGenerator /> : <Navigate to="/login" replace={true} />} />
          <Route path="/quiz-generator" element={user ? <QuizGenerator /> : <Navigate to="/login" replace={true} />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/redo-quiz" element={<Quiz />} />
          <Route path="/chat-history" element={user ? <ChatHistory /> : <Navigate to="/login" replace={true} />} />
          <Route path="/my-documents" element={user ? <MyDocuments /> : <Navigate to="/login" replace={true} />} />
          <Route path="/contact-us" element={user ? <ContactUs /> : <Navigate to="/login" replace={true} />} />
          <Route path="/my-schedule" element={user ? <MySchedule /> : <Navigate to="/login" replace={true} />} />
          <Route path="/setting" element={user ? <Setting /> : <Navigate to="/login" replace={true} />} />
          <Route path="/sharing" element={user ? <Sharing /> : <Navigate to="/login" replace={true} />} />
          <Route path="/plan" element={<Plan />} />
          <Route element={<NotFound />} />
        </Routes>
      </StoredUserContext.Provider>
    </Router>
  );
}


// const mapStateToProps = (state) => ({
//   user: state.auth.user, 
// });
// const mapDispatchToProps = {
//   Login,
// };

// export default connect(mapStateToProps,mapDispatchToProps)(App);
export default (App);
